import { memo } from "react";
import MaskService from "../../../../../utils/mask/maskService";

const { TableRow, TableCell } = require("@material-ui/core");

const GroupTotalRow = ({ total, columns, count }) => {
  return (
    <>
      <TableRow style={{ backgroundColor: "#ffcccb" }}>
        <TableCell colSpan={columns.length - 6}>Total:</TableCell>
        <TableCell align="right">
          {`${total?.documentAmount < 0 ? " - " : ""} ${MaskService.toMask(
            "decimal",
            parseFloat(total?.documentAmount ?? 0).toFixed(2),
            2
          )}`}
        </TableCell>

        <TableCell align="right">
          {`${total?.finishedAmount < 0 ? " - " : ""} ${MaskService.toMask(
            "decimal",
            parseFloat(total?.finishedAmount ?? 0).toFixed(2),
            2
          )}`}
        </TableCell>

        <TableCell align="right">
          {`${total?.increase < 0 ? " - " : ""} ${MaskService.toMask(
            "decimal",
            parseFloat(total?.increase ?? 0).toFixed(2),
            2
          )}`}
        </TableCell>

        <TableCell align="right">
          {`${total?.discount < 0 ? " - " : ""} ${MaskService.toMask(
            "decimal",
            parseFloat(total?.discount ?? 0).toFixed(2),
            2
          )}`}
        </TableCell>

        <TableCell align="right">
          {`${total?.originalAmount < 0 ? " - " : ""} ${MaskService.toMask(
            "decimal",
            parseFloat(total?.originalAmount ?? 0).toFixed(2),
            2
          )}`}
        </TableCell>

        <TableCell colSpan={2}></TableCell>
      </TableRow>
      <TableRow style={{ backgroundColor: "#d6e5ff" }}>
        <TableCell size="small" colSpan={columns.length}>
          Quantidade de Títulos: {count.toLocaleString("pt-BR")}
        </TableCell>
      </TableRow>
    </>
  );
};

export default memo(GroupTotalRow);
